import React, { useEffect, useState } from "react";
import styles from "./OpenBoosterButton.module.css";
import { boosterData, getBoosterById } from "../../../services/BoosterServices";
import Booster from "../../Boosters/Booster";
import globalStyles from "../../../styles/globalStyles.module.css";
import { Link, NavLink } from "react-router-dom";
import PastilleIcon from "../../CssIcon/PastilleIcon/PastilleIcon";
import { useOpenBoosterContext } from "../../../context/OpenBoosterProvider";
import sidebarStyles from "../../Sidebar/Sidebar.module.css";
import { FaList } from "react-icons/fa6";
import { useTranslation } from "react-i18next";

export const OpenBoosterButton: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { boostersId } = useOpenBoosterContext();
  const { t } = useTranslation();

  const toogleModal = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      {boostersId?.length > 0 && (
        <NavLink className={sidebarStyles.navLink} onClick={toogleModal} to="#">
          <div className={styles.iconWrapper}>
            <FaList />
          </div>
          <div className={styles.label}>{t("booster.open")}</div>

          <div className={styles.pastilleContainer}>
            <PastilleIcon>{boostersId?.length}</PastilleIcon>
          </div>
        </NavLink>
      )}
      <ShowBoostersToOpenModal
        isOpen={isOpen}
        handleClose={toogleModal}
        boostersId={boostersId!}
      />
    </>
  );
};

export const ShowBoostersToOpenModal: React.FC<{
  isOpen: boolean;
  handleClose: () => void;
  boostersId: string[];
}> = ({ isOpen, handleClose, boostersId }) => {
  const [boosters, setBoosters] = useState<boosterData[]>([]);

  useEffect(() => {
    if (!isOpen) {
      return;
    }

    const fetchBoosters = async () => {
      const existingIds = new Set(boosters.map((b) => b.id));
      const idsToFetch = boostersId.filter((id) => !existingIds.has(id));

      if (idsToFetch.length > 0) {
        try {
          const fetchedBoosters = await Promise.all(
            idsToFetch.map((id) => getBoosterById(id))
          );
          setBoosters((prev) => [...prev, ...fetchedBoosters]);
        } catch (error) {
          console.error("Failed to fetch boosters:", error);
        }
      }
    };

    fetchBoosters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, boostersId]);

  return (
    <>
      {isOpen && (
        <div className={styles.modalOverlay} onClick={handleClose}>
          <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
            <h1>Boosters to open</h1>
            <div className={styles.openAllContainer}>
              <button
                className={`${globalStyles.button} ${styles.openAllButton}`}
              >
                <strong>Open All {boosters.length} Boosters</strong>
              </button>
            </div>
            {boostersId.map((id, index) => {
              const booster = boosters.find((b) => b.id === id);
              if (!booster) return null;
              return (
                <div className={styles.boosterContainer} key={id}>
                  <Booster
                    booster={booster}
                    isInStore={true}
                    disableHover={true}
                  />
                  <div>
                    {booster.name}
                    <Link to={`/${booster.id}/open`} className={styles.unset}>
                      <button className={`${globalStyles.button}`}>
                        Open this booster
                      </button>
                    </Link>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};
